export default __webpack_public_path__ + "static/media/smile.d91f99f1.svg";